module.exports = __webpack_public_path__ + "static/ro-workshops-10-a86fa740cd1e104948a61146038072d5.jpg";